import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const LoadingScreen = () => {
  const { t } = useLanguage();

  return (
    <div className="fixed inset-0 bg-gray-100/95 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="flex flex-col items-center">
        {/* Logo animáció */}
        <div className="relative">
          {/* Belső pulzáló kör */}
          <div className="absolute inset-0 rounded-full bg-primary-500/20 animate-ping" />
          
          {/* Forgó gyűrű */}
          <div className="relative h-16 w-16">
            <div className="absolute inset-0 rounded-full border-4 border-primary-500/30 border-t-primary-500 animate-spin" />
          </div>

          {/* Külső pulzáló gyűrű */}
          <div className="absolute -inset-4 rounded-full border-2 border-primary-500/20 animate-pulse" />
        </div>

        {/* Betöltési szöveg */}
        <div className="mt-8 text-center">
          <p className="text-lg text-gray-800 font-medium">{t('common.loading')}</p>
          <div className="flex items-center justify-center mt-2 space-x-1">
            <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
            <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
            <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen; 